import { render, staticRenderFns } from "./AudioRecordPlayer.vue?vue&type=template&id=fc9c3d38&scoped=true&"
import script from "./AudioRecordPlayer.vue?vue&type=script&lang=ts&"
export * from "./AudioRecordPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./AudioRecordPlayer.vue?vue&type=style&index=0&id=fc9c3d38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9c3d38",
  null
  
)

export default component.exports